import { defineMessage, MessageDescriptor } from 'react-intl';

const payments: Record<string, MessageDescriptor> = {
  '-1': defineMessage({ defaultMessage: 'Other' }),
  '0': defineMessage({ defaultMessage: 'Cash' }),
  '1': defineMessage({ defaultMessage: 'Girocard' }),
  '2': defineMessage({ defaultMessage: 'Mastercard' }),
  '3': defineMessage({ defaultMessage: 'Visa' }),
  '4': defineMessage({ defaultMessage: 'Paypal' }),
  '5': defineMessage({ defaultMessage: 'Zettle' }),
  '6': defineMessage({ defaultMessage: 'Bank transfer' }),
  '7': defineMessage({ defaultMessage: 'AmEx' }),
  '8': defineMessage({ defaultMessage: 'Voucher' }),
  '9': defineMessage({ defaultMessage: 'CCV' }),
  '10': defineMessage({ defaultMessage: 'Paypal Code' }),
  '11': defineMessage({ defaultMessage: 'On Account' }),
  '12': defineMessage({ defaultMessage: 'SumUp' }),
  '13': defineMessage({ defaultMessage: 'Gift Card v1' }),
  '14': defineMessage({ defaultMessage: 'Payleven' }),
  '15': defineMessage({ defaultMessage: 'Atalanda' }),
  '16': defineMessage({ defaultMessage: 'BlueCode' }),
  '17': defineMessage({ defaultMessage: 'Wirecard' }),
  '18': defineMessage({ defaultMessage: 'Concardis' }),
  '19': defineMessage({ defaultMessage: 'Maestro' }),
  '20': defineMessage({ defaultMessage: 'VPay' }),
  '21': defineMessage({ defaultMessage: 'ShorePay' }),
};

export default payments;
